import PolicyEditComponents from "../components/PolicyEdit";
import usePolicyProps from "../hook/usePolicy";

const PolicyEdit = () => {
  const policyProps = usePolicyProps();
  return <PolicyEditComponents {...policyProps} />;
};

export default PolicyEdit;
